const chartColors = [
  {
    hex: '#BF55DA',
    id: 1
  },
  {
    hex: '#843EF7',
    id: 2
  },
  {
    hex: '#369EFF',
    id: 3
  },
  {
    hex: '#04D1D1',
    id: 4
  },
  {
    hex: '#0F71CC',
    id: 5
  },
  {
    hex: '#7223B0',
    id: 6
  },
  {
    hex: '#2D00AE',
    id: 7
  },
  {
    hex: '#009E9E',
    id: 8
  },
  {
    hex: '#E56000',
    id: 9
  },
  {
    hex: '#1A7B56',
    id: 10
  },
  {
    hex: '#45C7FF',
    id: 11
  },
  {
    hex: '#750E4C',
    id: 12
  },
  {
    hex: '#F5B013',
    id: 13
  },
  {
    hex: '#E21D45',
    id: 14
  },
  {
    hex: '#22C787',
    id: 15
  },
  {
    hex: '#A70064',
    id: 16
  },
  {
    hex: '#803194',
    id: 17
  },
  {
    hex: '#0D4D34',
    id: 18
  },
  {
    hex: '#C03212',
    id: 19
  },
  {
    hex: '#7B001E',
    id: 20
  }
]

export default chartColors
